<template>
  <div class="pageIndex">
    <!--      <van-popup v-model="popupOut">内容</van-popup>-->
    <div class="head">
      <div class="head-box">
        <!--          <div class="head-box-left">-->
        <!--            <van-icon name="cross" size="18px" color="#fefffe" />-->
        <!--          </div>-->
        <div style="width: 147px; margin: 0 auto">
          <img src="../assets/imgs/logo@2x.png" style="width: 100%; height: 100%" />
        </div>
      </div>
      <div class="head-info">
        <!--          <div class="info-w" v-if="isToken == 1">-->
        <!--            <img src="../assets/imgs/头像@2x.png" style="width: 100%;height: 100%">-->
        <!--          </div>-->
        <div class="info-w" @click="goLogin">
          <img src="../assets/imgs/头像@2x.png" style="width: 100%; height: 100%" />
        </div>

        <div class="head-font" v-if="isToken == 1">{{ userName }}</div>
        <div class="head-font" v-else @click="$router.push('/login')">登录/注册</div>
        <!--          退出按钮-->
        <div class="head-img" @click="goOut" v-if="isToken == 1">
          <img src="../assets/imgs/退出@2x.png" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>

    <div class="healthy">
      <div style="display: flex; flex-direction: column">
        <div style="display: flex">
          <!--            健康档案-->
          <!-- <div class="dangan" @click="$router.push('/health')">
            <img
              src="../assets/imgs/2.1home-健康档案@2x.png"
              style="width: 100%; height: 100%; position: absolute"
            />
            <div class="dangan-ws" v-if="isShow && isToken == 1">
              <img
                src="../assets/imgs/待完善@2x.png"
                style="width: 100%; height: 100%"
              />
            </div>
          </div> -->
          <div class="fangan fangan1" @click="$router.push('/health')">
            <img src="../assets/imgs/home-健康档案@2x.png" />
            <div>健康档案</div>
            <div class="dangan-ws" v-if="isShow && isToken == 1">
              <img src="../assets/imgs/待完善@2x.png" style="width: 100%; height: 100%" />
            </div>
          </div>
          <div class="fangan" @click="goLossWeight">
            <img src="../assets/imgs/2.1home-jianzhong@2x.png" />
            <div>减重方案</div>
          </div>
          <div class="fangan" @click="goCheck">
            <img src="../assets/imgs/2.1home-shuju@2x.png" />
            <div>数据检测</div>
          </div>
          <div class="fangan" @click="goSleep">
            <img src="../assets/imgs/2.1home-shuijiao@2x.png" />
            <div>睡眠记录</div>
          </div>
        </div>
        <div style="display: flex; margin-top: 8px">
          <!--<div class="flex1" @click="$toast('暂未开放')">-->
          <div class="flex1" @click="goTige()">
            <div class="box1">
              <img src="../assets/imgs/home-体格记录@2x.png" style="width: 100%; height: 100%" />
            </div>
            <div class="box2">体格记录</div>
          </div>
          <div class="mr-left flex1" @click="goFoods()">
            <div class="box1">
              <img src="../assets/imgs/home-饮食记录@2x.png" style="width: 100%; height: 100%" />
            </div>
            <div class="box2">饮食记录</div>
          </div>
          <div class="mr-left flex1" @click="goSport()">
            <div class="box1">
              <img src="../assets/imgs/home-运动记录@2x.png" style="width: 100%; height: 100%" />
            </div>
            <div class="box2">运动记录</div>
          </div>
          <div class="mr-left flex1" @click="goMessage()" v-if="isToken == 1">
            <div class="box1">
              <img src="../assets/imgs/2.2home-xiaoxi@2x.png" style="width: 100%; height: 100%" />
              <div class="msg" v-if="msgNum">
                {{ msgNum }}
              </div>
            </div>
            <div class="box2">我的消息</div>
          </div>
        </div>
      </div>
    </div>

    <div class="infomation">
      <div class="infomation-img">
        <img src="../assets/imgs/home-科普资讯@2x.png" style="width: 100%; height: 100%" />
      </div>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onload">
        <div>
          <div class="items" v-for="(item, index) in infoList" :key="index" @click="infoLinkto(item)">
            <div class="items-left">
              <img :src="item.indexpic" style="width: 100%; height: 100%" />
            </div>
            <div class="item-right">
              <div class="item-right-text">{{ item.title }}</div>
              <div class="item-right-data">{{ formatDate(item.publish_time) }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getUserInfo, userLogout } from "@/service/api";
import { Dialog } from "vant";
import axios from "axios";
import { wxshare } from "@/utils/wx";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      isShow: false, // 待完善图标
      pushToSport: false,
      isToken: "", //1、已登陆 2、未登陆
      userName: "",
      page: 0,
      infoList: [],
      loading: false,
      finished: false,
      msgNum: 0,
    };
  },
  created() {
    // this.wxshare();

    // // 看苏州app中分享
    // showShareBtn(
    //   JSON.stringify({
    //     title: this.share_info.title,
    //     brief: this.share_info.brief,
    //     imageLink: this.share_info.image,
    //     contentURL: this.share_info.url
    //   })
    // )

    // 进index判断浏览器缓存是否存在token渲染不同数据,
    if (localStorage.getItem("wa-token")) {
      this.isToken = 1;
      // 更新用户信息数据
      this.Userinfo();
    } else {
      this.isToken = 2; // 未登录
      console.log("未登录");
    }
  },
  methods: {
    wxshare() {
      console.log("执行"),
        wxshare({
          shareTitle: "test",
          shareDesc: "test",
          shareUrl: window.location.href,
          shareImg: "../assets/imgs/home-bg1@2x.png",
        });
    },
    goTige() {
      // if (this.isToken === 1) {
      //   this.$router.push("/physique");
      // } else {
      //   this.$router.push("/login");
      //   this.$toast("请先完成登录");
      // }
      if (this.pushToSport == false) {
        this.$router.push("/health");
        this.$toast("请先完成健康档案");
      } else {
        this.$router.push("/physique");
      }
    },
    goFoods() {
      if (this.pushToSport == false) {
        this.$router.push("/health");
        this.$toast("请先完成健康档案");
      } else {
        this.$router.push("/foodsList");
      }
    },
    goSport() {
      if (this.pushToSport == false) {
        this.$router.push("/health");
        this.$toast("请先完成健康档案");
      } else {
        this.$router.push("/sport");
      }
    },
    goMessage() {
      if (this.isToken === 1) {
        this.$router.push("/myMessage");
      } else {
        this.$router.push("/login");
        this.$toast("请先完成登录");
      }
    },
    // 减重方案
    goLossWeight() {
      if (this.pushToSport == false) {
        this.$router.push("/health");
        this.$toast("请先完成健康档案");
      } else {
        this.$router.push("/loseweight");
      }
    },
    // 数据检测
    goCheck() {
      if (this.pushToSport == false) {
        this.$router.push("/health");
        this.$toast("请先完成健康档案");
      } else {
        this.$router.push("/check");
      }
    },
    // 睡眠记录
    goSleep() {
      if (this.pushToSport == false) {
        this.$router.push("/health");
        this.$toast("请先完成健康档案");
      } else {
        this.$router.push("/sleep");
      }
    },
    infoLinkto(content) {
      if (content.module_id == "news") {
        if (content.outlink) {
          if (item.outlink.indexOf("StudioLiveDetails") > -1) {
            let zb_id = item.outlink.split("id=")[1];
            window.open("https://h5.kan0512.com/szd/live/scene/" + zb_id);
          } else {
            window.open(content.outlink);
          }
        } else {
          let type = "";
          let url = "";
          if (content.indexpic.indexOf("51kandianshi") > 0) {
            type = "contentcenter";
          }
          if (type == "contentcenter") {
            url = "https://h5.kan0512.com/ksz/tw/#/article/contentcenter/index?id=" + content.id;
          } else {
            url = "https://h5.kan0512.com/ksz/tw/#/article/index?id=" + content.id;
          }
          window.open(url);
        }
      }
    },
    // 科普资讯
    onload() {
      console.log("onload");
      axios
        .get(
          "https://mobile.kan0512.com/szh/column_detail.php?appkey=mmv6bfo799vcDHqfZBlqtDp4NHCCb4xn&appid=36&column_id=1026&offset=" +
            this.page +
            "&count=10"
        )
        .then((res) => {
          console.log("this.res", res);
          this.infoList = [...this.infoList, ...res.data.data];
          this.page += 1;
          this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          } else {
            console.log("加载成功");
          }
        })
        .catch((err) => {
          this.finished = true;
          this.$toast("网络请求异常", err);
        });
    },
    // 日期格式
    formatDate(time) {
      let date = new Date(parseInt(time)*1000)
      let year = date.getFullYear();
      let mon = date.getMonth() + 1;
      let day = date.getDate();
      let s = year + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);
      return s;
    },
    Userinfo() {
      getUserInfo()
        .then((res) => {
          this.pushToSport = res.data.health;
          this.isShow = !res.data.health;
          this.userName = res.data.info.nickname;
          this.msgNum = res.data.unread_msg_num;
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    goOut() {
      Dialog.confirm({
        title: "确认是否退出?",
      })
        .then(() => {
          userLogout()
            .then((res) => {
              this.$toast(res.msg);
              localStorage.clear();
              this.$router.replace("/login");
            })
            .catch((err) => {
              this.$toast(err.message);
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    goLogin() {
      if (this.isToken == 1) {
        this.$toast("您已登录");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pageIndex {
  width: 100%;
  height: 100%;
  .head {
    height: 180px;
    background-image: url("../assets/imgs/home-bg1@2x.png");
    background-size: 100% 80%;
    background-repeat: no-repeat;
    padding-top: 49px;
    padding-left: 16px;
    /*padding-right: 16px;*/
    .head-box {
      height: 30px;
      display: flex;
      align-items: center;
    }
    .head-info {
      height: 56px;
      margin-top: 25px;
      display: flex;
      /*justify-content : center;*/
      align-items: center;
      /*justify-content : space-between;*/
      .info-w {
        width: 56px;
        height: 56px;
      }
    }
    .head-font {
      /*width: 150px;*/
      font-size: 16px;
      font-weight: 500;
      margin-left: 12px;
      line-height: 56px;
      color: #ffffff;
    }
    .head-img {
      width: 71px;
      height: 28px;
      margin-left: auto;
      margin-right: 1px;
    }
  }
  .healthy {
    padding: 16px 12px 16px 12px;
    margin-top: -73px;
    height: 350px;
    background-image: url("../assets/imgs/bg@2x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .dangan {
      flex: 1;
      height: 72px;
      // width: 232px;
      // width: 20%;
      position: relative;
      .dangan-ws {
        width: 66px;
        height: 22px;
        position: absolute;
        right: 1px;
        top: 2px;
      }
    }
    .fangan {
      box-sizing: border-box;
      flex: 1;
      height: 76px;
      margin-left: 8px;
      background: #d2e8f7;
      border-radius: 12px;
      font-size: 14px;
      text-align: center;
      padding: 13px 0;
      color: #222222;
      img {
        width: 28px;
        height: 28px;
      }
    }
    .fangan1 {
      position: relative;
      margin-left: 0;
      .dangan-ws {
        width: 66px;
        height: 22px;
        position: absolute;
        right: 1.5px;
        top: 2px;
      }
    }
    .flex1 {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      height: 56px;
      background: #d2e8f7;
      align-items: center;
      border-radius: 12px;
      padding: 10px 0;
      /*padding-top: 14px;*/
      /*padding-left: 10px;*/
      /*padding-top: ;*/
      .box1 {
        // margin-left: 10px;
        width: 26px;
        height: 26px;
        position: relative;
        .msg {
          position: absolute;
          top: -6px;
          right: -9px;
          width: 16px;
          height: 16px;
          background: #ff3141;
          border: 1px solid #ecf2f1;
          border-radius: 50%;
          color: #ffffff;
          font-size: 10px;
          line-height: 16px;
          text-align: center;
        }
      }
      .box2 {
        width: 100%;
        text-align: center;
        // margin-left:5px;
        font-size: 14px;
        font-weight: 500;
        color: #222222;
      }
    }
    .mr-left {
      margin-left: 8px;
    }
  }
  .infomation {
    padding: 0px 16px;
    margin-top: -190px;
    .infomation-img {
      width: 77px;
      height: 16.5px;
    }
    .items {
      display: flex;
      margin-top: 16px;
      height: 75px;
      /*background: pink;*/
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      .items-left {
        width: 80px;
        height: 60px;
      }
      .item-right {
        margin-left: 12px;
        /*width: 100%;*/
        display: flex;
        flex-direction: column;
        .item-right-text {
          width: 251px;
          height: 40px;
          font-size: 15px;
          font-weight: 400;
          text-align: left;
          color: #222222;
          line-height: 20px;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          /*line-clamp: 2;*/
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }
        .item-right-data {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 18px;
          height: 18px;
        }
      }
    }
  }
}
</style>
